export const DEFAULT_LOCALE = 'en';
export const SUPPORTED_LOCALES = ['en', 'nl', 'fr', 'de', 'it', 'es'];
export const LOCALE_COOKIE_NAME = 'invoicepoint_locale';

export const LOCALE_LABELS = {
    en: 'English',
    nl: 'Nederlands',
    fr: 'Français',
    de: 'Deutsch',
    it: 'Italiano',
    es: 'Español'
};

export const ROUTE_PATHS = {
    home: '/',
    loader: '/loader',
    freelancers: '/freelancers',
    organization: '/organization',
    smallBusiness: '/small-business',
    privacyPolicy: '/privacy-policy',
    faqs: '/faqs',
    termsOfService: '/terms-of-service',
    cookiePolicy: '/cookie-policy',
    onlinePayments: '/online-payments',
    pricing: '/pricing',
    invoiceGenerator: '/invoice-generator',
    contractors: '/contractors',
    handymen: '/handymen',
    cleaners: '/cleaners',
    // Features
    aiEstimator: '/features/ai-estimator',
    invoicing: '/features/invoicing',
    quotes: '/features/quotes',
    timeTracking: '/features/time-tracking',
    payments: '/features/payments',
    paymentReminders: '/features/payment-reminders',
    clients: '/features/clients',
    expenses: '/features/expenses',
    reports: '/features/reports',
    // Resources
    helpCenter: '/resources/help-center',
    howItWorks: '/resources/how-it-works',
    templates: '/resources/templates',
    guides: '/resources/guides',
    blog: '/resources/blog',
    contact: '/resources/contact'
};

export const LOCALE_ROUTE_PREFIX = '/:locale(en|nl|fr|de|it|es)';

// Map ISO 3166-1 alpha-2 country codes to supported locales
export const COUNTRY_TO_LOCALE = {
    // English
    US: 'en', GB: 'en', CA: 'en', AU: 'en', NZ: 'en', IE: 'en', ZA: 'en',
    // Dutch
    NL: 'nl', SR: 'nl',
    // French
    FR: 'fr', MC: 'fr', LU: 'fr', SN: 'fr', CI: 'fr', ML: 'fr', CM: 'fr',
    // German
    DE: 'de', AT: 'de', LI: 'de',
    // Italian
    IT: 'it', SM: 'it', VA: 'it',
    // Spanish
    ES: 'es', MX: 'es', AR: 'es', CO: 'es', CL: 'es', PE: 'es', VE: 'es',
    EC: 'es', GT: 'es', CU: 'es', DO: 'es', HN: 'es', SV: 'es', NI: 'es',
    CR: 'es', PA: 'es', UY: 'es', PY: 'es', BO: 'es',
    // Multilingual — pick primary locale
    BE: 'nl', CH: 'de',
};